<template>
    <div class="page">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <!-- @71144 - Aba de listagem de ocorrências no menu cultura (Módulo agro)-->
        <div class="vertical-flow">
            <!-- PESQUISA E FILTROS -->
            <div class="columns is-multiline search-filters">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-busca-agro-ass-cultura"
                    />
                </div>

                <!-- SITUACAO -->
                <div
                    class="column situacao-select"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoInput"
                        title="situacao"
                        :options="situacoes"
                        :mlLabels="true"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                        :height="40"
                        :clearable="true"
                    />
                </div>

                <!-- BOTÕES -->
                <div class="column is-3" v-if="this.permissaoVincular">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularOcorrencia"
                    >
                        {{ $t('vincular-ocorrencia') }}
                    </button>
                </div>

                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="TelaCadastroOcorrencia"
                    >
                        {{ $t('adicionar-ocorrencia') }}
                    </button>
                </div>
            </div>

            <!-- LISTAGEM -->
            <div class="cultura-table registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="allocorrencias"
                    :mobile-cards="false"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        class="td-center"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <span v-if="permissao.update && permiteAtualizar">
                                <b-button
                                    class="action-button"
                                    :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                    :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')
                                    "
                                />
                            </span>
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['situacao'] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else-if="f.key == 'nomepopular' && permissao.update">
                            <router-link
                                :to="{
                                    name: `${abrev}-ocorrencia-edit`,
                                    params: { id: props.row.idagro_ocorrencia },
                                    query: {
                                        tela: `${abrev}-cultura-edit`,
                                        id: $route.params.id,
                                        contexto: $route.meta.contexto,
                                    },
                                }"
                            >
                                <pre>{{ props.row[f.key] }}</pre>
                            </router-link>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <OcorrenciaModal
                        :idCultura="$route.params.id"
                        :permissaoVincular="!service"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import AssOcorrenciaService from '@/services/agro/ocorrencia/AssOcorrenciaCulturaService';
import OcorrenciaModal from '@/components/agro/cultura/modal/OcorrenciaModal';

export default {
    components: {
        OcorrenciaModal,
    },
    data() {
        return {
            assCulturaOcorrenciaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_ASSOCORRENCIACULTURA'
            ),
            ocorrenciaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_OCORRENCIA'
            ),
            allocorrencias: [],
            service: new AssOcorrenciaService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: '7.5%', sortable: true, sortFn: null },
                { key: 'nomepopular', width: null, sortable: true, sortFn: null },
                { key: 'nomecientifico', width: null, sortable: true, sortFn: null },
                { key: 'tipo', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            msgs: [],
            situacoes: [
                { label: 'todos', id: 2 },
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            situacao: { label: 'todos', id: 2 },
            sort: {
                order: 'asc',
                column: 'nomepopular',
            },
            permissao: {},
            permissaoOcorrencia: {},
            permissaoVincular: false,
            permissaoCadastrar: false,
            permiteAtualizar: false,
            showModalAssociacao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            queryFilter: '.*',
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        // Seleciona o valor na posição do array de opções de paginação
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-cultura');
            this.permissaoOcorrencia = this.hasPermissionAccess(
                'agro',
                'agro-cadastros',
                'agro-ocorrencia'
            );
        } else {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-cultura');
            this.permissaoOcorrencia = this.hasPermissionAccess('vendas', 'crm', 'ven-ocorrencia');
        }

        this.permissaoVincular = this.permissao.create && !this.assCulturaOcorrenciaIntegracao;
        this.permissaoCadastrar =
            this.permissaoOcorrencia.create &&
            !this.ocorrenciaIntegracao &&
            this.permissao.create &&
            !this.assCulturaOcorrenciaIntegracao;

        this.permiteAtualizar = this.permissao.update && !this.assCulturaOcorrenciaIntegracao;

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-ocorrencia` },
            });

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados(1);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.$route.params.id,
                    this.abrev,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.allocorrencias = value;
                    this.isEmpty = this.allocorrencias.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            if (body && body.content) {
                this.pagination.totalRows = body.totalElements;
                let ocorrenciaslist = body.content.map((mf) => {
                    return {
                        id: mf.idagro_assocorrenciacultura,
                        codigo: mf.agroOcorrencia.idagro_ocorrenciaerp,
                        nomepopular: mf.agroOcorrencia.nomepopular,
                        nomecientifico: mf.agroOcorrencia.nomecientifico,
                        idtipocultura: mf.idtipocultura,
                        idagro_ocorrencia: mf.idagro_ocorrencia,
                        idtipoocorrencia: mf.agroOcorrencia.idagro_tipoocorrencia,
                        tipo: mf.agroOcorrencia.agroTipoOcorrencia.descricao,
                        situacao: mf.situacao,
                    };
                });
                return ocorrenciaslist;
            } else {
                return [];
            }
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['nomepopular'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.updateSituacaoRegistro(),
                onCancel: (_) => this.removePrompt(),
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            this.isLoading = true;

            let ocorrenciaTemp = {
                idagro_assocorrenciacultura: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.service
                .updateSituacao(ocorrenciaTemp, this.abrev)
                .then((r) => {
                    if (r.status == 200) {
                        if (r.content.situacao == 1) {
                            this.$root.showMessage('success', 'msg-sucesso-ao-reativar-ocorrencia');
                        } else if (r.content.situacao == 0) {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-desativar-ocorrencia'
                            );
                        }
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status do vincular.', e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularOcorrencia() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
        TelaCadastroOcorrencia() {
            this.$router.push({
                name: `${this.abrev}-ocorrencia-new`,
                query: {
                    tela: `${this.abrev}-cultura-edit`,
                    id: this.$route.params.id,
                    descricao: this.$route.params.descricao,
                    contexto: this.$route.meta.contexto,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    padding: 20px 20px;
    height: 100%;
    position: relative;
    padding-left: 0;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }
    .situacao-select div {
        height: 40px;
    }
}
</style>
